import http, { endpoints } from '../http';
import { groupCaseTextsFromDto, initializeTextGroups, mapCaseTextFromDto } from './helpers';
const efktClient = http.createClient(endpoints.efkt);
/**
 * EFKT-MOCK DOMAIN — Efkt has no copywrite/texts capability at all today (confirmed: no route, no
 * domain, in the Efkt backend). Mirrors datahub's `TextsApi` (`datahub/texts/index.ts`) 1:1. Every path
 * below is an unconfirmed guess following Efkt's REST conventions — grep `EFKT-MOCK` across this
 * package for every placeholder like this one.
 */
export default class TextsApi {
    /** EFKT-MOCK — guessed. Mirrors datahub's `TextsApi.getCaseTexts`. */
    static async getCaseTexts(caseId) {
        const response = await efktClient.get(`/api/case/${encodeURIComponent(caseId)}/texts`);
        return groupCaseTextsFromDto(response.data);
    }
    /**
     * EFKT-MOCK — guessed. Mirrors datahub's `TextsApi.getTextGroups` (`GET /Texts/GetAllTextSections`):
     * the global, non-per-case text-section catalogue that defines which tabs `useTranslatedTexts`
     * shows. Attempted for every Efkt-sourced case, same as the datahub half.
     */
    static async getTextGroups() {
        const response = await efktClient.get('/api/text-sections');
        return initializeTextGroups(response.data);
    }
    /** EFKT-MOCK — guessed. Mirrors datahub's `TextsApi.saveCaseText`. */
    static async saveCaseText({ caseId, name, content }) {
        const body = { content };
        await efktClient.put(`/api/case/${encodeURIComponent(caseId)}/texts/${encodeURIComponent(name)}`, body);
    }
    /** EFKT-MOCK — guessed. Mirrors datahub's `TextsApi.getTextHistory`. */
    static async getCaseTextHistory({ caseId, name }) {
        const response = await efktClient.get(`/api/case/${encodeURIComponent(caseId)}/texts/${encodeURIComponent(name)}/history`);
        return response.data.map(mapCaseTextFromDto);
    }
}
